import api from '@/api/index.js'

const account_top_up = {
  state: {
    loading: false,
    updating: false,
    data: null,
    // createdMoneyClaimId: null,
    // updatedMoneyClaim: null,
    error: null,
  },

  mutations: {
    SET_ACCOUNT_TOP_UP_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_TOP_UP_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_ACCOUNT_TOP_UP: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_TOP_UP_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
  },

  actions: {
    LoadAccountTopUp({commit}, req) {
      commit('SET_ACCOUNT_TOP_UP_LOADING', true)
      commit('SET_ACCOUNT_TOP_UP_ERROR', null)
      return api.get(`accounts/${req.accountID}/top-ups/${req.topUpID}`)
        .then((response) => {
          commit('SET_ACCOUNT_TOP_UP', response)
          commit('SET_ACCOUNT_TOP_UP_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_TOP_UP_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    ReinitiateAccountTopUp({dispatch, commit}, req) {
      commit('SET_ACCOUNT_TOP_UP_UPDATING', true)
      commit('SET_ACCOUNT_TOP_UP_ERROR', null)
      return api.put(`accounts/${req.accountID}/top-ups/${req.topUpID}/re-initiate`)
        .then((response) => {
          commit('SET_ACCOUNT_TOP_UP_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_ACCOUNT_TOP_UP_ERROR', error)
          commit('SET_ACCOUNT_TOP_UP_UPDATING', false);

        })
    },
    VerifyAccountOneOffTopUp({dispatch, commit}, req) {
      commit('SET_ACCOUNT_TOP_UP_UPDATING', true)
      commit('SET_ACCOUNT_TOP_UP_ERROR', null)
      return api.put(`accounts/${req.accountID}/top-ups/${req.topUpID}/verify`)
        .then((response) => {
          commit('SET_ACCOUNT_TOP_UP_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_ACCOUNT_TOP_UP_ERROR', error)
          commit('SET_ACCOUNT_TOP_UP_UPDATING', false);

        })
    },
    ReduceAccountTopUpRetries({dispatch, commit}, req) {
      commit('SET_ACCOUNT_TOP_UP_UPDATING', true)
      commit('SET_ACCOUNT_TOP_UP_ERROR', null)
      return api.put(`accounts/${req.accountID}/top-ups/${req.topUpID}/reduce-retries`)
        .then((response) => {
          commit('SET_ACCOUNT_TOP_UP_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_ACCOUNT_TOP_UP_ERROR', error)
          commit('SET_ACCOUNT_TOP_UP_UPDATING', false);

        })
    },
  },
}

export default account_top_up
